export default {
  sitekey: '6Ld2Ec8ZAAAAAD3EDakDdEQxn9oQFpmaS5cDoi-0',
};
